var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { InputLabel } from '../../input';
import { FormControl } from '../form-control';
import { FormHelperText } from '../form-helper-text';
import clsx from '../../utils/clsx';
import { useId } from '../../utils/use-id';
import { useMergedClasses } from '../../styles/classes';
import { formFieldClasses, getFormFieldUtilityClass } from './form-field-classes';
var isFormControlRenderer = function (children) { return typeof children === 'function'; };
export var FormField = React.forwardRef(function (props, ref) {
    var idProp = props.id, children = props.children, helperText = props.helperText, error = props.error, label = props.label, hiddenLabel = props.hiddenLabel, disabled = props.disabled, readOnly = props.readOnly, InputLabelProps = props.InputLabelProps, FormHelperTextProps = props.FormHelperTextProps, ErrorHelperTextProps = props.ErrorHelperTextProps, 
    // remove to avoid forwarding to the root
    className = props.className, sx = props.sx, propClasses = props.classes, rootProps = __rest(props, ["id", "children", "helperText", "error", "label", "hiddenLabel", "disabled", "readOnly", "InputLabelProps", "FormHelperTextProps", "ErrorHelperTextProps", "className", "sx", "classes"]);
    var classes = useMergedClasses(formFieldClasses, getFormFieldUtilityClass, propClasses);
    var id = useId(idProp);
    var controlId = "".concat(id, "-control");
    var helperTextId = helperText ? "".concat(id, "-helperText") : undefined;
    var errorTextId = error ? "".concat(id, "-feedback") : undefined;
    return (React.createElement(FormControl, __assign({ className: clsx(classes.root, className), disabled: readOnly || disabled, error: !!error }, rootProps, { sx: sx, ref: ref }),
        label && !hiddenLabel && (React.createElement(InputLabel, __assign({ className: classes.label, htmlFor: controlId }, InputLabelProps), label)),
        isFormControlRenderer(children)
            ? children({ controlId: controlId, helperTextId: helperTextId, errorTextId: errorTextId })
            : React.Children.map(children, function (child) {
                if (!child) {
                    return null;
                }
                if (!React.isValidElement(child)) {
                    return child;
                }
                return React.cloneElement(child, {
                    id: controlId,
                    readOnly: readOnly || disabled,
                    'aria-label': hiddenLabel ? label : '',
                    'aria-describedby': clsx(helperTextId, errorTextId),
                });
            }),
        !!error && (React.createElement(FormHelperText, __assign({ className: classes.error, "aria-live": "polite", error: true, id: errorTextId }, ErrorHelperTextProps), error)),
        !!helperText && (React.createElement(FormHelperText, __assign({ className: classes.helperText, error: false, id: helperTextId }, FormHelperTextProps), helperText))));
});
